export const resolveABTestData = (getProductList, products, filters) => {
    try {
        return typeof getProductList === 'function' ? getProductList(products, filters) : { products };
    } catch (e) {
        return { products };
    }
};

/**
 * Returns the segment of the tab relative path containing only the vanityUrl and the PG key
 */
export const getRelativeTabPathFromPG = pg => {
    let [vanityUrl, , key] = pg.key.split(':');
    return `${vanityUrl}/${key}`;
};

/**
 * Returns the tab key from the path constructed from getRelativeTabPathFromPG
 */
export const getTabKeyFromPath = path => {
    return path.split('/').pop();
};

/**
 * Return the vanityUrl containing the tab key of the active tab
 */
export const getActiveTabPath = (productGroups, relativePathToMatch, basename) => {
    if (
        !Array.isArray(productGroups) ||
        productGroups.length === 0 ||
        typeof relativePathToMatch !== 'string' ||
        relativePathToMatch.length === 0
    ) {
        return;
    }

    for (let pg of productGroups) {
        try {
            let currentRelativePath = getRelativeTabPathFromPG(pg);
            let completeRelativePath = basename ? `${basename}/${currentRelativePath}` : currentRelativePath;
            if (completeRelativePath === relativePathToMatch) {
                return currentRelativePath;
            }
        } catch (e) {}
    }
};

export const getSubVanityUrl = (slugInfo, routerPathname, siteConfig) => {
    try {
        if ('sale-v3' === slugInfo.templateKey) {
            // TODO: Check if there are SLPs that have & in the tab name (it shouldn't)
            // don't treat filter selections as a separate page views by disregarding the path after "&"
            let lowerCasedPathname = routerPathname && routerPathname.toLowerCase().split('?')[0].split('&')[0];
            return getActiveTabPath(
                slugInfo.components.productTab.productGroups,
                lowerCasedPathname,
                siteConfig?.basename,
            );
        }
    } catch (e) {}
};
